import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_ACTION_BAR_CONTENT} from "../constants/homematch_tinder_content";
import {HomematchThumbDirection} from "../types/HomematchThumbDirection";

import * as styles from "./HomematchTinderActionBar.module.css";

const {ASK_BUTTON, REJECT_BUTTON, VENDOR_LOGO_ALT, getLeadInfoText} = HOMEMATCH_TINDER_ACTION_BAR_CONTENT;

interface IProps {
    askButtonLabel?: string;
    askDataTestId?: string;
    disabled?: boolean;
    leadInfoText?: string | null;
    onThumbClick: (direction: HomematchThumbDirection) => void;
    rejectButtonLabel?: string;
    rejectDataTestId?: string;
    showLeadInfoText?: boolean;
    vendorLogoUrl?: string | null;
    vendorName?: string | null;
}

export const HomematchTinderActionBar = (props: IProps) => {
    const {
        askButtonLabel = ASK_BUTTON,
        askDataTestId,
        disabled = false,
        leadInfoText,
        onThumbClick,
        rejectButtonLabel = REJECT_BUTTON,
        rejectDataTestId,
        showLeadInfoText = true,
        vendorLogoUrl,
        vendorName
    } = props;

    const {isMobile} = useUserDevice();

    const defaultLeadInfoText = vendorName ? getLeadInfoText(vendorName) : undefined;
    const visibleLeadInfoText = leadInfoText === undefined ? defaultLeadInfoText : leadInfoText;
    const resolvedLeadInfoText = showLeadInfoText ? visibleLeadInfoText : null;
    const hasVendorInfo = Boolean(vendorLogoUrl || resolvedLeadInfoText);
    const buttonSize = isMobile ? "small" : "medium";

    return (
        <div className={styles.bar}>
            {hasVendorInfo && (
                <div className={styles.vendorRow}>
                    {vendorLogoUrl && <Image alt={VENDOR_LOGO_ALT} className={styles.vendorLogoWrapper} height="48" src={vendorLogoUrl} width="64" />}

                    {resolvedLeadInfoText && <Text variant="body_copy_2">{resolvedLeadInfoText}</Text>}
                </div>
            )}

            <div className={styles.buttonsRow}>
                <Button
                    className={styles.button}
                    dataTestId={rejectDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbDownIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Down)}
                    size={buttonSize}
                    variant="outlined_secondary"
                >
                    {rejectButtonLabel}
                </Button>

                <Button
                    className={styles.button}
                    dataTestId={askDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbUpIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Up)}
                    size={buttonSize}
                    variant="filled_primary"
                >
                    {askButtonLabel}
                </Button>
            </div>
        </div>
    );
};
import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_ACTION_BAR_CONTENT} from "../constants/homematch_tinder_content";
import {HomematchThumbDirection} from "../types/HomematchThumbDirection";

import * as styles from "./HomematchTinderActionBar.module.css";

const {ASK_BUTTON, REJECT_BUTTON, VENDOR_LOGO_ALT, getLeadInfoText} = HOMEMATCH_TINDER_ACTION_BAR_CONTENT;

interface IProps {
    askButtonLabel?: string;
    askDataTestId?: string;
    disabled?: boolean;
    leadInfoText?: string | null;
    onThumbClick: (direction: HomematchThumbDirection) => void;
    rejectButtonLabel?: string;
    rejectDataTestId?: string;
    showLeadInfoText?: boolean;
    vendorLogoUrl?: string | null;
    vendorName?: string | null;
}

export const HomematchTinderActionBar = (props: IProps) => {
    const {
        askButtonLabel = ASK_BUTTON,
        askDataTestId,
        disabled = false,
        leadInfoText,
        onThumbClick,
        rejectButtonLabel = REJECT_BUTTON,
        rejectDataTestId,
        showLeadInfoText = true,
        vendorLogoUrl,
        vendorName
    } = props;

    const {isMobile} = useUserDevice();

    const defaultLeadInfoText = vendorName ? getLeadInfoText(vendorName) : undefined;
    const visibleLeadInfoText = leadInfoText === undefined ? defaultLeadInfoText : leadInfoText;
    const resolvedLeadInfoText = showLeadInfoText ? visibleLeadInfoText : null;
    const hasVendorInfo = Boolean(vendorLogoUrl || resolvedLeadInfoText);
    const buttonSize = isMobile ? "small" : "medium";

    return (
        <div className={styles.bar}>
            {hasVendorInfo && (
                <div className={styles.vendorRow}>
                    {vendorLogoUrl && <Image alt={VENDOR_LOGO_ALT} className={styles.vendorLogoWrapper} height="48" src={vendorLogoUrl} width="64" />}

                    {resolvedLeadInfoText && <Text variant="body_copy_2">{resolvedLeadInfoText}</Text>}
                </div>
            )}

            <div className={styles.buttonsRow}>
                <Button
                    className={styles.button}
                    dataTestId={rejectDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbDownIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Down)}
                    size={buttonSize}
                    variant="outlined_secondary"
                >
                    {rejectButtonLabel}
                </Button>

                <Button
                    className={styles.button}
                    dataTestId={askDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbUpIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Up)}
                    size={buttonSize}
                    variant="filled_primary"
                >
                    {askButtonLabel}
                </Button>
            </div>
        </div>
    );
};
